import MaxWidthContainer from "@/features/Common/components/MaxWidthContainer";
import { maxWidthConfig } from "@/theme";
import { lazy, LazyExoticComponent } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

interface PublicBinahScanFlowProps {
  onCompletedFlow?: () => void;
}

const PublicBinahScanFlow: LazyExoticComponent<
  React.FC<PublicBinahScanFlowProps>
> = lazy(() => import("@/features/HealthCheck/components/PublicBinahScanFlow"));

export default function Router() {
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state as {
    from: string;
    isRedirected: boolean;
  };
  const from = locationState && locationState.from;

  const maxWidth = maxWidthConfig.defaultMaxWidth;

  return (
    <ScrollToTop>
      <MaxWidthContainer maxWidth={maxWidth}>
        <Routes location={from || location}>
          <Route index element={<Navigate to="/binah-scan" replace />} />
          <Route
            path="/binah-scan"
            element={
              <PublicBinahScanFlow
                onCompletedFlow={() => navigate("/binah-scan")}
              />
            }
          />
          <Route
            path="*"
            element={<Navigate to="/" state={{ isRedirected: true }} />}
          />
        </Routes>
      </MaxWidthContainer>
    </ScrollToTop>
  );
}
